import React from "react";
import { observer } from "mobx-react-lite";
import { MidiPortsSelect } from "./midi/MidiPortsSelect";
import { DeviceInfo } from "./DeviceInfo";
import { faExternalLinkAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { stores } from "../stores";
import "./Header.css";

export const Header = observer(() => {
    const deviceType = stores.state.currentDeviceType;
    
    const getDeviceImage = (): string | undefined => {
        switch (deviceType) {
            case "DPC-8EZ Gen3":
                return "dpc_8ez.png";
            case "DPC.micro":
            case "DPC.micro Gen3":
            case "DPC.micro Gen4":
                return "dpc_micro.png";
            default:
                return undefined;
        }
    };

    const getDeviceLabel = (): string | undefined => {
        switch (deviceType) {
            case "DPC-8EZ Gen3":
                return "DPC-8EZ";
            case "DPC.micro":
            case "DPC.micro Gen3":
            case "DPC.micro Gen4":
                return "DPC.micro";
            default:
                return undefined;
        }
    };

    const deviceImage = getDeviceImage();
    const deviceLabel = getDeviceLabel();

    console.log("Header render - deviceType:", deviceType);
    console.log("Header render - deviceImage:", deviceImage);
    console.log("Header render - deviceLabel:", deviceLabel);

    return (
        <div className="header">
            <div className="logo">
                <a href="https://www.disasterareadesigns.com/" target="_blank" rel="noopener noreferrer">
                    <img src="DA_LOGO_WEB.png" alt="Disaster Area Designs logo" className="logo-image" />
                </a>
            </div>
            <div className="header-lines">
                <div className="header-top-line">
                    <div className="header-title">
                        DISASTER AREA - Configuration Editor
                    </div>
                    <div>
                        Editor v{process.env.REACT_APP_VERSION} by Disaster Area Designs & <a href="http://studiocode.dev/" target="_blank" rel="noopener noreferrer">StudioCode.dev</a>
                    </div>
                </div>
                <div className="row baseline between pt-10">
                    <MidiPortsSelect />
                    <div>
                        <a href="https://www.disasterareadesigns.com/support" target="_blank" rel="noopener noreferrer">Support <FontAwesomeIcon icon={faExternalLinkAlt} /></a>
                    </div>
                </div>
                <div className="row baseline between pt-10">
                    <DeviceInfo />
                </div>
            </div>
            <div className="right-picture">
                {deviceImage && deviceLabel ? (
                    <>
                        <a href="https://www.disasterareadesigns.com/shop/p/dpc-micro" target="_blank" rel="noopener noreferrer">
                            <img src={deviceImage} alt={deviceLabel} className="right-image" />
                        </a>
                        <div className="right-image-label">{deviceLabel}</div>
                    </>
                ) : (
                    <div>No device detected</div>
                )}
            </div>
        </div>
    );
});